import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import SEO from "../components/SEO";
import { C, F } from "../tokens";

const Error = () => (
  <>
    <SEO
      title="Page introuvable"
      description="La page que vous cherchez n'existe pas ou a été déplacée. Revenez à l'accueil du site de Maxime Nicolaieff, ostéopathe D.O. à Balma et Castelnau-d'Estrétefonds."
      path="/404"
      noIndex
    />
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: "1.5rem",
        textAlign: "center",
        background: C.bg,
        pt: "68px",
      }}
    >
      <Typography
        sx={{
          fontFamily: F.display,
          fontSize: "clamp(5rem, 15vw, 9rem)",
          fontWeight: 300,
          color: C.border,
          lineHeight: 1,
          mb: "1rem",
        }}
      >
        404
      </Typography>
      <Typography
        variant="h1"
        component="h1"
        sx={{ fontSize: "clamp(1.3rem, 3vw, 2rem)", fontWeight: 500, color: C.text, mb: "1rem" }}
      >
        Page introuvable
      </Typography>
      <Typography
        sx={{ fontSize: ".95rem", color: C.textMuted, maxWidth: "400px", lineHeight: 1.7, mb: "2.5rem" }}
      >
        La page que vous cherchez n'existe pas ou a été déplacée.
        Revenez à l'accueil pour retrouver votre chemin.
      </Typography>
      <Box
        component={Link}
        to="/"
        sx={{
          display: "inline-block",
          px: "1.75rem",
          py: ".75rem",
          background: C.primary,
          color: "#fff",
          borderRadius: "50px",
          fontSize: ".88rem",
          fontWeight: 500,
          textDecoration: "none",
          transition: "background .2s ease",
          "&:hover": { background: C.accent },
        }}
      >
        Retour à l'accueil
      </Box>
    </Box>
  </>
);

export default Error;
